import { BarChart } from '@mantine/charts'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => {
  if (!p.data || !Array.isArray(p.data)) return null
  return (
    <BarChart
      {...p}
      data={p.data}
      dataKey={p.dataKey}
      tickLine={p.tickLine}
      series={p.series ?? [{ name: 'y', color: 'blue' }]}
      legendProps={{
        layout: 'horizontal',
        verticalAlign: p.legendVerticalAlign ?? 'bottom',
        ...(p.customProps?.legendProps || {}),
      }}
      {...p.customProps}
    />
  )
})
